import React, { CSSProperties, ReactChild } from 'react';
import cc from 'classcat';
import C from './TagList.css';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

export interface Tag {
  id: string;
  label: string;
  icon: ReactChild;
  more?: boolean;
}

export default function TagList(p: {
  tags: Tag[];
  onSelect: (tagId: string) => void;
  selectedId: string;
  style?: CSSProperties;
  className?: string;
  small?: boolean;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const tags = p.tags.filter((tag) => !tag.more);
  const moreTags = p.tags.filter((tag) => tag.more);
  return (
    <ul
      className={cc([C.tagList, p.className, ...(p.small ? [C.small] : [])])}
      style={p.style}
    >
      {tags.map((tag) => {
        return (
          <li key={tag.id}>
            <button
              onClick={() => {
                p.onSelect(tag.id);
              }}
              className={cc({
                [C.activeItem]: p.selectedId === tag.id,
              })}
            >
              {tag.icon}
              {tag.label}
            </button>
          </li>
        );
      })}
      {moreTags.length > 0 && (
        <li>
          <button
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            <MoreHorizIcon />
            More
          </button>
          <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => {
              setAnchorEl(null);
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <Box>
              <List
                style={
                  {
                    // background: 'var(--color-selected)',
                  }
                }
              >
                {moreTags.map((tag) => (
                  <MenuItem
                    key={tag.id}
                    selected={p.selectedId === tag.id}
                    onClick={() => {
                      p.onSelect(tag.id);
                    }}
                  >
                    <Stack
                      alignItems='center'
                      sx={{
                        '& svg': {
                          width: '1rem',
                        },
                      }}
                    >
                      {tag.icon}
                    </Stack>
                    &nbsp;&nbsp;
                    <Typography variant='body2'>{tag.label}</Typography>
                  </MenuItem>
                ))}
              </List>
            </Box>
          </Menu>
        </li>
      )}
    </ul>
  );
}
